import { combineReducers } from '@reduxjs/toolkit';
import authentication from './authentication';
import loader from './loader';
import home from './home';
import prosure from './prosure';

const rootReducer = combineReducers({
  authentication,
  loader,
  home,
  prosure
});

export default rootReducer;
